import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutReplyResults extends Layout {
    replyResultsTable: Table;
    sourceReplyResults: DataSource;
}
